import React from "react";
import { Button, ButtonSize } from "../../../../components/Button";
import { useWallet } from "../../../../hooks/useWallet";
import { useAuth } from "../../../../hooks/useAuth";
import { RestoreWalletForm } from "./RestoreWalletForm";
import { ButtonVariant } from "../../../../config/colors";

export const WalletOtherActive: React.FC = () => {
  const { pleb } = useAuth();
  const { createNewWallet } = useWallet();

  return (
    <div className="flex flex-col items-center justify-center text-center gap-4">
      <div className="text-base opacity-70 mb-4">
        You already have a self-custodial wallet in the mobile app. Please copy the 12 words (seed phrase) from the wallet in the mobile app, and paste them here to import the wallet. Your seed phrase stays on your device and is never sent to our servers.
      </div>

      <RestoreWalletForm />

      <div className="mt-4 flex flex-col items-center gap-2 text-sm opacity-70">
        <span>
        If you have lost the seed phrase or the mobile device, click here to create a new wallet.
        </span>
        <Button
          size={ButtonSize.small}
          variant={ButtonVariant.semiTransparent}
          onClick={() => {
            if (pleb) {
              createNewWallet(pleb);
            }
          }}
        >
          Create New Wallet
        </Button>
      </div>
    </div>
  );
};

